import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "circle",
  id: "circle"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "wave" }, null, -1)

import { onBeforeUnmount, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Line',
  setup(__props) {

const line = ref<HTMLElement | null>(null);
const lineBaseHeight = 50;

function onScroll() {
  // get one percent of window height
  const x = window.innerHeight / 100;

  // find out how much to add to the line height
  // so that the line increases when scrolling
  const y = Math.floor(window.scrollY / x);
  if (line.value) {
    line.value.style.height = lineBaseHeight + y + "vh";
  }
}

onMounted(() => {
  window.addEventListener("scroll", onScroll);
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "line",
      id: "line",
      ref_key: "line",
      ref: line
    }, null, 512),
    _hoisted_1,
    _hoisted_2
  ], 64))
}
}

})